import * as React from "react";
import _ from "lodash";
import EditDriveTest from "../../Editing/EditDriveTest";
import Table from "../../../components/Table/Table";
import { editActions } from "../../../actions/editActions";
import { Dimmer } from "semantic-ui-react";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";

/**
 * All the following props are passed from parent component
 */
export type DriveTestsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.DriveSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.DriveSubmenu, columnFilter: Filter[]) => void;
};

type DriveTestsTableState = {
  isModalOpen: boolean;
};

export class DriveTestsTable extends React.Component<DriveTestsTableProps, DriveTestsTableState> {
  state = {
    isModalOpen: false
  };

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal } = this.props;
    const { driveTests } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    const driveTestRows: Api.DriveTest[] = driveTests;
    let selectedColumns: State.Column[] = [];

    selectedColumns = columns["Drive Tests"];
    const startingPage = mainState.lastEditedObjectId
      ? (driveTestRows.findIndex(driveTest => driveTest.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
        mainState.pageSize) >>
      0
      : 0;
    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={driveTestRows}
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isDriveTestSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditDriveTest toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }
  /**
   * Returns status if driveTest has been selected
   * @param {Api.AnyParameter} fault
   * @returns {boolean}
   */
  private isDriveTestSelected = (driveTest: Api.DriveTest): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && driveTest.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default DriveTestsTable;
